import { render, staticRenderFns } from "./ItemSelection.vue?vue&type=template&id=5b0de8c2&scoped=true&"
import script from "./ItemSelection.vue?vue&type=script&lang=js&"
export * from "./ItemSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0de8c2",
  null
  
)

export default component.exports